import { MobileBridge } from "@wwg/mobile-bridge";
import { createContext } from "react";

/**
 * Holds a shared instance of MobileBridge that components can tap into with useMobileBridge.
 */
export const MobileBridgeContext = createContext<MobileBridge>(null);
